import { RootState } from "interfaces/generics.type";
import { useSelector } from "react-redux";

function FallBack() {
  return <span />;
}

function withSession(WrappedComponent: any, FallbackComponent = FallBack) {
  function HOC(props: any) {
    const refreshStatus = useSelector((state: RootState) => state.authenticationState.refreshStatus);

    const isLoading = useSelector((state: RootState) => state.garage.isLoading);
    if (refreshStatus === "complete" && isLoading === false) {
      return (
        <WrappedComponent {...props} />
      );
    }
    return (
      <FallbackComponent
        {...props}
      />
    );
  }
  return HOC;
}

export default withSession;
